const shareURLFor = (socialNetwork) => {
  const encodedURL = encodeURIComponent(window.location.href)

  switch (socialNetwork) {
    case 'facebook':
      return `https://www.facebook.com/sharer.php?u=${encodedURL}`
    case 'twitter':
      return `https://twitter.com/share?url=${encodedURL}`
    case 'linkedin':
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodedURL}`
  }
}

export {
  shareURLFor
}
